class ItemFormHelper {
  constructor() {
    this.multiBannerState = null;
    this.bannerState = null;
    this.articleState = null;
    this.contentState = null;
    this.adsState = null;
    this.printableState = null;
  }

  //-------------content---------------------

  setContentState(state) {
    this.contentState = state;
  }

  getContentState() {
    return this.contentState;
  }

  //-----------Ads-----------------------

  setAdsState(state) {
    this.adsState = state;
  }

  getAdsState() {
    return this.adsState;
  }

  //---------------Printable-------------------

  setPrintableState(state) {
    this.printableState = state;
  }

  getPrintableState() {
    return this.printableState;
  }

  //----------------Banners------------------

  setBannersState(state) {
    this.bannersState = state;
  }

  getBannersState() {
    return this.bannersState;
  }

  //----------------Article------------------

  setArticleState(state) {
    this.articleState = state;
  }

  getArticleState() {
    return this.articleState;
  }

  //---------------Teaser-------------------

  setTeaserState(state) {
    this.teaserState = state;
  }

  getTeaserState() {
    return this.teaserState;
  }




  //--------------unused--------------------
  setMultiBannerState(state) {
    this.multiBannerState = state;
  }

  getMultiBannerState() {
    return this.multiBannerState;
  }

  //---------------unused-------------------
  setBannerState(state) {
    this.bannerState = state;
  }

  getBannerState() {
    return this.bannerState;
  }
  //----------------------------------

}

export default new ItemFormHelper();
